<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px;">VIP 质检</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>用户信息查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="app-container">
        <!-- 筛选区 -->
        <div class="filter-card">
          <div class="filter-grid">
            <div class="field-item">
              <label>用户名</label>
              <el-input v-model="listQuery.user_name" placeholder="请输入用户名" clearable></el-input>
            </div>
            <div class="field-item">
              <label>角色 ID</label>
              <el-input v-model="listQuery.role_id" placeholder="请输入角色 ID" clearable></el-input>
            </div>
            <div class="field-item">
              <label>角色名称</label>
              <el-input v-model="listQuery.role_name" placeholder="请输入角色名称" clearable></el-input>
            </div>
            <div class="field-item">
              <label>手机号</label>
              <el-input v-model="listQuery.mobile" placeholder="请输入手机号" clearable></el-input>
            </div>
            <div class="field-item">
              <label>运营游戏</label>
              <el-select
                v-model="selectedYunGames"
                multiple
                filterable
                remote
                clearable
                collapse-tags
                reserve-keyword
                :remote-method="searchLocalYunGame"
                :loading="yunGameSearching"
                placeholder="输入至少 2 个字符搜索 appKey / 游戏名称"
                style="width: 100%;"
                @visible-change="handleYunGameVisibleChange"
              >
                <el-option
                  v-for="g in yunGameSelectOptions"
                  :key="g.value"
                  :label="g.label"
                  :value="g.value"
                ></el-option>
              </el-select>
            </div>
            <div class="field-item">
              <label>区服 ID</label>
              <el-input v-model="listQuery.server_id" placeholder="请输入区服 ID" clearable></el-input>
            </div>
            <div class="field-item">
              <label>天网游戏</label>
              <el-select
                v-model="listQuery.chat_app_ids"
                multiple
                filterable
                clearable
                collapse-tags
                placeholder="选择天网游戏（可多选）"
              >
                <el-option v-for="g in skyNetGameOptions" :key="g.id" :label="g.name" :value="g.id"></el-option>
              </el-select>
            </div>
          </div>

          <div class="filter-actions">
            <el-button type="primary" icon="el-icon-search" :loading="listLoading" @click="search">搜索</el-button>
            <el-button type="warning" @click="reset">重置</el-button>
          </div>
        </div>

        <!-- 结果区 -->
        <div class="result-card">
          <div class="table-wrap">
            <el-table
              border
              v-loading="listLoading"
              :data="tableData"
              style="width: 100%;"
              empty-text="请输入条件后点击搜索"
            >
              <el-table-column
                v-for="col in effectiveColumns"
                :key="col.field"
                :prop="col.field"
                :label="col.title"
                :min-width="columnMinWidth(col.field)"
                :show-overflow-tooltip="isTooltipColumn(col.field)"
              >
                <template slot-scope="scope">
                  <component
                    :is="cellRenderer(col.field)"
                    v-if="cellRenderer(col.field)"
                    :row="scope.row"
                    :field="col.field"
                  />
                  <span v-else>{{ scope.row[col.field] | dash }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="140">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="openDrawer(scope.row)">查看详情</el-button>
                  <el-divider direction="vertical"></el-divider>
                  <el-button type="text" size="mini" @click="handleCopy(scope.row)">复制</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

        </div>

        <UserDrawer ref="drawer" />
      </div>
    </div>
  </div>
</template>

<script>
import UserDrawer from './UserDrawer.vue';
import HighlightText from './HighlightText.vue';
import PayQualCell from './PayQualCell.vue';
import {
  getGameUserInfo,
  getSameYunGameTree,
  getSkyNetGameOption,
} from '@/api/vipQualityTest';
import {
  validateQuery,
  buildCopyText,
  copyToClipboard,
  getDeviceLoginRecords,
} from './utils';

const buildEmptyQuery = () => ({
  user_name: '',
  role_id: '',
  role_name: '',
  mobile: '',
  app_keys: [],
  server_id: '',
  chat_app_ids: [],
});

// 列宽（min-width）
const COLUMN_MIN_WIDTH = {
  platformStr: 80,
  userName: 110,
  telNum: 120,
  userId: 100,
  appname: 160,
  appkey: 110,
  roleName: 130,
  roleId: 140,
  serverId: 110,
  realName: 180,
  deviceLoginRecords: 180,
  registerTimeDisplay: 160,
  loginTimeRange: 240,
  payTimeRange: 240,
  purchasedGoodsNames: 200,
  rechargeTotalAll: 130,
  rechargeTotalByRole: 130,
  rechargeTotalBiweekly: 140,
  payQualifications: 100,
  chats: 130,
};

const TOOLTIP_COLUMNS = new Set([
  'realName',
  'deviceLoginRecords',
  'purchasedGoodsNames',
  'appname',
]);

// 默认列定义（用户进入页面尚未搜索 / 后端未返回 columns 时展示，搜索成功后由后端 columns 覆盖）
const DEFAULT_COLUMNS = [
  { title: '平台', field: 'platformStr' },
  { title: '用户名', field: 'userName' },
  { title: '手机号', field: 'telNum' },
  { title: '用户ID', field: 'userId' },
  { title: '游戏', field: 'appname' },
  { title: 'appkey', field: 'appkey' },
  { title: '角色名称', field: 'roleName' },
  { title: '角色 ID', field: 'roleId' },
  { title: '区服 ID', field: 'serverId' },
  { title: '实名信息', field: 'realName' },
  { title: '设备信息', field: 'deviceLoginRecords' },
  { title: '注册时间', field: 'registerTimeDisplay' },
  { title: '登录时间区间', field: 'loginTimeRange' },
  { title: '充值时间区间', field: 'payTimeRange' },
  { title: '充值内容', field: 'purchasedGoodsNames' },
  { title: '充值金额（所有）', field: 'rechargeTotalAll' },
  { title: '充值金额（条件）', field: 'rechargeTotalByRole' },
  { title: '充值金额（双周）', field: 'rechargeTotalBiweekly' },
  { title: '支付资质下金额', field: 'payQualifications' },
  { title: '未成年聊天情况', field: 'chats' },
];

const YUN_GAME_MIN_SEARCH_LENGTH = 2;
const YUN_GAME_SEARCH_LIMIT = 100;

function buildYunGameSearchIndex(tree, parentLabels = []) {
  if (!Array.isArray(tree)) return [];
  return tree.reduce((acc, item) => {
    const label = item.text || item.name || '';
    const pathLabels = label ? [...parentLabels, label] : parentLabels;
    const appKey = item.appKey != null ? String(item.appKey) : '';
    const id = item.id != null ? String(item.id) : '';
    const children = Array.isArray(item.children) ? item.children : [];

    if (appKey) {
      const displayPath = pathLabels.join(' / ');
      acc.push({
        value: appKey,
        label: displayPath ? `${displayPath}（${appKey}）` : appKey,
        searchText: [displayPath, label, appKey, id].join(' ').toLowerCase(),
      });
    }

    if (children.length > 0) {
      acc.push(...buildYunGameSearchIndex(children, pathLabels));
    }
    return acc;
  }, []);
}

// 自定义渲染单元（functional 组件，cell 内直接调用工具函数 / HighlightText）
const renderers = {
  // 实名信息：服务端合并为单字段 realName
  realName: {
    functional: true,
    render(h, ctx) {
      const r = ctx.props.row || {};
      return h('span', r.realName || '-');
    },
  },
  deviceLoginRecords: {
    functional: true,
    render(h, ctx) {
      const list = getDeviceLoginRecords(ctx.props.row);
      if (list.length === 0) return h('span', '-');
      const types = [...new Set(list.map(d => d.deviceType).filter(Boolean))];
      const top5 = types.slice(0, 5).join('、');
      const text = `${top5}${types.length > 5 ? '…' : ''}`;
      return h('span', { attrs: { title: types.join('、') } }, text);
    },
  },
  // 登录时间区间：服务端字段 loginTimeRange 自带 {{}} 标记
  loginTimeRange: {
    functional: true,
    render(h, ctx) {
      const r = ctx.props.row || {};
      return h(HighlightText, { props: { text: r.loginTimeRange || '-', variant: 'tag' } });
    },
  },
  // 充值时间区间：服务端字段 payTimeRange 自带 {{}} 标记
  payTimeRange: {
    functional: true,
    render(h, ctx) {
      const r = ctx.props.row || {};
      return h(HighlightText, { props: { text: r.payTimeRange || '-', variant: 'tag' } });
    },
  },
  purchasedGoodsNames: {
    functional: true,
    render(h, ctx) {
      const arr = (ctx.props.row && ctx.props.row.purchasedGoodsNames) || [];
      const text = arr.length > 0 ? arr.join('、') : '-';
      return h('span', { attrs: { title: arr.join('、') } }, text);
    },
  },
  serverId: {
    functional: true,
    render(h, ctx) {
      const r = ctx.props.row || {};
      const parts = [r.serverId, r.serverName].filter(Boolean);
      return h('span', parts.join(' / ') || '-');
    },
  },
  chats: {
    functional: true,
    render(h, ctx) {
      const c = ctx.props.row && ctx.props.row.chats;
      return h('span', (c && c.desc) || '-');
    },
  },
  // 支付资质下金额：列表只放查询按钮，点击 popover 显示结果
  payQualifications: PayQualCell,
};

export default {
  name: 'userInfoQuery',
  components: { UserDrawer, HighlightText, PayQualCell },
  filters: {
    dash(v) {
      if (v == null || v === '') return '-';
      return v;
    },
  },
  data() {
    return {
      listQuery: buildEmptyQuery(),
      tableData: [],
      total: 0,
      listLoading: false,
      // 后端返回的动态列定义（受角色权限 page_user_info 控制）
      dynamicColumns: [],

      // 运营游戏本地搜索选择器
      yunGameSearchResults: [],
      yunGameSearching: false,
      selectedYunGames: [],

      // 天网游戏
      skyNetGameOptions: [],

      // 防 stale-response
      listRequestSeq: 0,
    };
  },
  computed: {
    // 实际渲染的列：后端 columns 优先，没有时用本地默认列定义（保证空表格也有列头预览）
    effectiveColumns() {
      return this.dynamicColumns && this.dynamicColumns.length > 0
        ? this.dynamicColumns
        : DEFAULT_COLUMNS;
    },
    yunGameSelectOptions() {
      const selectedOptions = this.selectedYunGames
        .map(value => this.yunGameOptionMap && this.yunGameOptionMap[String(value)])
        .filter(Boolean);
      const optionMap = new Map();
      [...selectedOptions, ...this.yunGameSearchResults].forEach(item => {
        optionMap.set(item.value, item);
      });
      return Array.from(optionMap.values());
    },
  },
  created() {
    this.yunGameSearchIndex = Object.freeze([]);
    this.yunGameOptionMap = Object.freeze({});
    this.loadYunGameTree();
    this.loadSkyNetGameOption();
  },
  methods: {
    columnMinWidth(field) {
      return COLUMN_MIN_WIDTH[field] || 120;
    },
    isTooltipColumn(field) {
      return TOOLTIP_COLUMNS.has(field);
    },
    cellRenderer(field) {
      return renderers[field] || null;
    },

    // ============ 选择器加载 ============
    async loadYunGameTree() {
      try {
        const res = await getSameYunGameTree();
        if (res && res.data && res.data.code === 200) {
          this.applyYunGameTree(res.data.data || []);
        }
      } catch (e) {
        // 接口未通时静默；用户搜索时仍可输入其他条件
      }
    },
    applyYunGameTree(tree) {
      const index = buildYunGameSearchIndex(tree);
      const optionMap = index.reduce((acc, item) => {
        acc[item.value] = item;
        return acc;
      }, {});
      this.yunGameSearchIndex = Object.freeze(index);
      this.yunGameOptionMap = Object.freeze(optionMap);
      this.yunGameSearchResults = [];
    },
    searchLocalYunGame(keyword) {
      const q = (keyword || '').trim().toLowerCase();
      if (q.length < YUN_GAME_MIN_SEARCH_LENGTH) {
        this.yunGameSearchResults = [];
        return;
      }

      this.yunGameSearching = true;
      const results = [];
      const source = this.yunGameSearchIndex || [];
      for (let i = 0; i < source.length && results.length < YUN_GAME_SEARCH_LIMIT; i++) {
        if (source[i].searchText.includes(q)) {
          results.push(source[i]);
        }
      }
      this.yunGameSearchResults = results;
      this.yunGameSearching = false;
    },
    handleYunGameVisibleChange(visible) {
      if (!visible) {
        this.yunGameSearchResults = [];
      }
    },
    async loadSkyNetGameOption() {
      try {
        const res = await getSkyNetGameOption();
        if (res && res.data && res.data.code === 200) {
          this.skyNetGameOptions = res.data.data || [];
        }
      } catch (e) {
        // 同上
      }
    },

    // ============ 防 stale ============
    isResponseStale(seq, fingerprint) {
      if (seq !== this.listRequestSeq) return true;
      return fingerprint !== JSON.stringify(this.buildRequestParams());
    },

    // ============ 搜索 ============
    async search() {
      this.listQuery.app_keys = Array.isArray(this.selectedYunGames) ? [...this.selectedYunGames] : [];

      const v = validateQuery(this.listQuery);
      if (!v.ok) {
        this.$message.warning(v.msg);
        return;
      }
      const seq = ++this.listRequestSeq;
      const params = this.buildRequestParams();
      const fingerprint = JSON.stringify(params);
      this.listLoading = true;
      try {
        const res = await getGameUserInfo(params);
        if (this.isResponseStale(seq, fingerprint)) return;
        if (res && res.data && res.data.code === 200) {
          this.applyListData(res.data.data);
        } else {
          this.handleListFailure((res && res.data && res.data.message) || '查询失败');
        }
      } catch (e) {
        if (this.isResponseStale(seq, fingerprint)) return;
        this.handleListFailure('查询失败');
      } finally {
        if (seq === this.listRequestSeq) this.listLoading = false;
      }
    },
    applyListData(payload) {
      if (!payload) {
        this.tableData = [];
        this.total = 0;
        this.dynamicColumns = [];
        return;
      }
      const inner = payload.data && typeof payload.data === 'object' ? payload.data : {};
      this.dynamicColumns = Array.isArray(inner.columns) ? inner.columns : [];
      this.tableData = Array.isArray(inner.list) ? inner.list : [];
      this.total = Number(payload.total || 0);
    },
    handleListFailure(msg) {
      this.tableData = [];
      this.total = 0;
      this.$message.error(msg);
    },
    buildRequestParams() {
      const q = this.listQuery;
      const params = {
        user_name: (q.user_name || '').trim(),
        role_id: (q.role_id || '').trim(),
        role_name: (q.role_name || '').trim(),
        mobile: (q.mobile || '').trim(),
        server_id: (q.server_id || '').trim(),
      };
      if (Array.isArray(q.app_keys) && q.app_keys.length > 0) {
        params.app_keys = q.app_keys;
      }
      if (Array.isArray(q.chat_app_ids) && q.chat_app_ids.length > 0) {
        params.chat_app_ids = q.chat_app_ids;
      }
      return params;
    },

    // ============ 重置 ============
    reset() {
      this.listRequestSeq++;
      this.listQuery = buildEmptyQuery();
      this.selectedYunGames = [];
      this.tableData = [];
      this.total = 0;
      this.dynamicColumns = [];
      this.listLoading = false;
    },

    // ============ 抽屉 ============
    openDrawer(row) {
      this.$refs.drawer.open(row);
    },

    // ============ 复制 ============
    handleCopy(row) {
      const text = buildCopyText(row);
      copyToClipboard(text)
        .then(() => this.$message.success('数据已复制到粘贴板'))
        .catch(() => this.$message.error('数据复制失败'));
    },
  },
};
</script>

<style lang="less" scoped>
.filter-card {
  background: #fff;
  padding: 16px 20px 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  margin-bottom: 16px;
}
.filter-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px 16px;
}
@media (max-width: 1400px) {
  .filter-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 1100px) {
  .filter-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
.field-item {
  display: flex;
  flex-direction: column;
  label {
    font-size: 12px;
    color: #595959;
    margin-bottom: 4px;
    .hint {
      color: #8c8c8c;
    }
  }
  /deep/ .el-date-editor,
  /deep/ .el-select,
  /deep/ .el-cascader,
  /deep/ .el-input {
    width: 100%;
  }
}
.filter-actions {
  margin-top: 14px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  .rule-tip {
    margin-left: 12px;
    color: #8c8c8c;
    font-size: 12px;
  }
}
.result-card {
  background: #fff;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}
.table-wrap {
  overflow-x: auto;
}
</style>
